<!-- Eng -->
@if (isEng) {
  <div class="common-sub-container theme-cookiePage__bg">
    <div class="common-container" [ngClass]="{ 'common-container--color-settings': colorSettingsMode }">
      <h1 class="common-sub-block__h1 theme-cookiePage__mainTitle">Cookie Policy for Beatmakers.tv</h1>
      <p class="common-sub-block__descr">
        This is the Cookie Policy for Beatmaker.tv, accessible from
        <a class="common-sub-block__link theme-cookiePage__link" href="https://beatmakers.tv/"
          >https://www.beatmakers.tv
        </a>
      </p>
      <h3 class="common-sub-block__title cookies-block__title theme-cookiePage__subTitle">What Are Cookies</h3>
      <p class="common-sub-block__descr">
        As is common practice with almost all professional websites this site uses cookies, which are tiny files that
        are downloaded to your computer, to improve your experience. This page describes what information they gather,
        how we use it and why we sometimes need to store these cookies. We will also share how you can prevent these
        cookies from being stored however this may downgrade or 'break' certain elements of the sites functionality. For
        more general information on cookies see the Wikipedia article on HTTP Cookies.
      </p>
      <h3 class="common-sub-block__title cookies-block__title theme-cookiePage__subTitle">How We Use Cookies</h3>
      <p class="common-sub-block__descr">
        We use cookies for a variety of reasons detailed below. Unfortunately in most cases there are no industry
        standard options for disabling cookies without completely disabling the functionality and features they add to
        this site. It is recommended that you leave on all cookies if you are not sure whether you need them or not in
        case they are used to provide a service that you use.
      </p>
      <h3 class="common-sub-block__title cookies-block__title theme-cookiePage__subTitle">Disabling Cookies</h3>
      <p class="common-sub-block__descr">
        You can prevent the setting of cookies by adjusting the settings on your browser (see your browser Help for how
        to do this). Be aware that disabling cookies will affect the functionality of this and many other websites that
        you visit. Disabling cookies will usually result in also disabling certain functionality and features of the
        this site. Therefore it is recommended that you do not disable cookies. You can learn how to manage cookies on
        your web browser by following the
        <a
          class="common-sub-block__link theme-cookiePage__link"
          href="https://www.privacypolicies.com/blog/browser-cookies-guide/"
          >Browser Cookies Guide</a
        >.
      </p>
      <h3 class="common-sub-block__title cookies-block__title theme-cookiePage__subTitle">The Cookies We Set</h3>
      <ul class="common-sub-block__descr">
        <li>
          <span class="cookies-block__subtitle">1. Account related cookies.</span>
          If you create an account with us then we will use cookies for the management of the signup process and general
          administration. These cookies will usually be deleted when you log out however in some cases they may remain
          afterwards to remember your site preferences when logged out.
        </li>
        <li>
          <span class="cookies-block__subtitle">2. Log in related cookies.</span> We use cookies when you are logged in
          so that we can remember this fact. This prevents you from having to log in every single time you visit a new
          page. These cookies are typically removed or cleared when you log out to ensure that you can only access
          restricted features and areas when logged in.
        </li>
        <li>
          <span class="cookies-block__subtitle">3. Email newsletters related cookies.</span>
          This site offers newsletter or email subscription services and cookies may be used to remember if you are
          already registered and whether to show certain notifications which might only be valid to
          subscribed/unsubscribed users.
        </li>
        <li>
          <span class="cookies-block__subtitle">4. Site preferences cookies</span>
          In order to provide you with a great experience on this site we provide the functionality to set your
          preferences for how this site runs when you use it. In order to remember your preferences we need to set
          cookies so that this information can be called whenever you interact with a page is affected by your
          preferences.
        </li>
      </ul>
      <h3 class="common-sub-block__title cookies-block__title theme-cookiePage__subTitle">Third Party Cookies</h3>
      <p>
        In some special cases we also use cookies provided by trusted third parties. The following section details which
        third party cookies you might encounter through this site.
      </p>
      <ul class="common-sub-block__descr">
        <li>
          This site uses Google Analytics which is one of the most widespread and trusted analytics solution on the web
          for helping us to understand how you use the site and ways that we can improve your experience. These cookies
          may track things such as how long you spend on the site and the pages that you visit so we can continue to
          produce engaging content. For more information on Google Analytics cookies, see the official Google Analytics
          page
        </li>
        <li>
          Third party analytics are used to track and measure usage of this site so that we can continue to produce
          engaging content. These cookies may track things such as how long you spend on the site or pages you visit
          which helps us to understand how we can improve the site for you.
        </li>
        <li>
          We also use social media buttons and/or plugins on this site that allow you to connect with your social
          network in various ways. For these to work the following social media sites including: Twitter, Facebook, VK,
          SoundCloud, YouTube, will set cookies through our site which may be used to enhance your profile on their site
          or contribute to the data they hold for various purposes outlined in their respective privacy policies.
        </li>
      </ul>
      <h3 class="common-sub-block__title cookies-block__title theme-cookiePage__subTitle">More Information</h3>
      <p>
        Hopefully that has clarified things for you and as was previously mentioned if there is something that you
        aren't sure whether you need or not it's usually safer to leave cookies enabled in case it does interact with
        one of the features you use on our site. This Cookies Policy was created with the help of the Generator of.
      </p>
      <p>
        However if you are still looking for more information then you can contact us through one of our preferred
        contact methods:
      </p>
      <p>
        By email:
        <a class="common-sub-block__link theme-cookiePage__link" href="mailto:support@beatmaker.tv"
          >support&#64;beatmaker.tv</a
        >
      </p>
    </div>
  </div>
}

<!-- Ru -->
@if (!isEng) {
  <div class="common-sub-container theme-cookiePage__bg">
    <div class="common-container" [ngClass]="{ 'common-container--color-settings': colorSettingsMode }">
      <h1 class="common-sub-block__h1 theme-cookiePage__mainTitle">Политика куки</h1>
      <h3 class="common-sub-block__title cookies-block__title theme-cookiePage__subTitle">Cookie-файлы</h3>
      <p class="common-sub-block__descr">
        Cookie — это небольшой текстовый файл, содержащий Ваши данные, который сохраняется при каждом посещении сайта
        или приложения. Такие файлы помогают сайтам и приложениям запомнить Ваши предыдущие действия, даже если они были
        совершены Вами несколько месяцев или несколько лет назад. К таким действиям может относиться переход по
        определенным ссылкам или перемещение между страницами, вход в систему или выбор той или иной информации на
        странице. Существуют разные типы cookie-файлов, без которых интернет-сайты, приложения и прочие цифровые услуги
        не могли бы функционировать в привычном для Вас режиме. Например, при подтверждении входа в систему без
        cookie-файла интернет-сайт не смог бы отобразить Вашу персональную страницу, или же при каждом посещении
        интернет-сайта на экране появлялось бы сообщение «зарегистрируйтесь для входа в систему», так как интернет-сайт
        не мог бы запомнить Ваши учетные данные. Вы всегда можете удалить существующие cookie-файлы или даже полностью
        заблокировать их использование на интернет-сайтах.
      </p>
      <h3 class="common-sub-block__title cookies-block__title theme-cookiePage__subTitle">Типы cookie-файлов</h3>
      <ul class="common-sub-block__descr">
        <li class="common-sub-block__descr">
          <span class="cookies-block__subtitle">Строго необходимые Cookie-файлы.</span> Существуют cookie-файлы, без
          которых навигация по интернет-сайтам, а также использование их функциональных характеристик, таких как доступ
          к безопасным зонам, стали бы невозможными. Без таких файлов пользователь не может зарегистрироваться или войти
          в систему. Эти cookie-файлы не сохраняют какую-либо информацию о Вас, которая может быть использована в
          маркетинговых целях или для учета посещаемых Вами сайтов в сети Интернет.
        </li>
        <li class="common-sub-block__descr">
          <span class="cookies-block__subtitle">Аналитические Cookie-файлы.</span>
          Эти файлы применяются для сбора информации о том, как пользователи используют Сайт, например, какие страницы
          они посещают чаще всего и получают ли сообщения об ошибках. Они не применяются для сбора информации,
          позволяющей установить личность пользователя; вся информация является анонимной. Она используется
          исключительно для совершенствования функциональных характеристик сайта или приложения.
        </li>
        <li class="common-sub-block__descr">
          <span class="cookies-block__subtitle">Функциональные Cookie-файлы.</span>
          Такие файлы используются для сбора данных о пользовательских настройках (например, имя пользователя, выбранный
          пользователем язык или регион), на основании которых веб-сайт предлагает пользователю усовершенствованные
          персональные функции. Функциональные Cookie-файлы могут запомнить информацию об изменениях, внесенных Вами в
          размер текста или тип шрифта, а также о других настройках, доступных для пользователей. Они также могут
          предоставлять информацию об используемых Вами ресурсах интернет-сайтов, таких как, например, просмотр
          видео-ролика или сохранение комментария в блоге. При необходимости, информацию, собираемую данными файлами,
          можно сделать анонимной. Они также отслеживают другие сайты и приложения, которые Вы посещаете.
        </li>
        <li>
          <span class="cookies-block__subtitle">Целевые Cookie-файлы.</span>
          Эти файлы позволяют отображать рекламу или сообщения на интересующую Вас тему. Иногда целевые cookie-файлы
          могут содержать ссылки на другие сайты, таки как, например, Facebook.com. Описанные выше типы cookie-файлов
          могут иметь характер «временных» (сеансовые» cookie-файлы) или «долгосрочных» (постоянные» cookie-файлы).
        </li>
      </ul>
    </div>
  </div>
}
